enum SimplifiReportRequest {
  Total = 'SIMPLIFI_TOTAL',

  Date = 'SIMPLIFI_DATE',
  Channel = 'SIMPLIFI_CHANNEL',
  Device = 'SIMPLIFI_DEVICE',
  Publisher = 'SIMPLIFI_PUBLISHER',
  Campaign = 'SIMPLIFI_CAMPAIGN',
  Creative = 'SIMPLIFI_CREATIVE',
  Advertiser = 'SIMPLIFI_ADVERTISER',
  GeoState = 'SIMPLIFI_GEO_STATE',
  GeoDma = 'SIMPLIFI_GEO_DMA',
  GeoCounty = 'SIMPLIFI_GEO_COUNTY',
  GeoZip = 'SIMPLIFI_GEO_ZIP',
  GeoZip4 = 'SIMPLIFI_GEO_ZIP4',
  GeoCity = 'SIMPLIFI_GEO_CITY',
  GeoCongressionalDistrict = 'SIMPLIFI_GEO_CONGRESSIONAL_DISTRICT',
  DayOfWeek = 'SIMPLIFI_DAY_OF_WEEK',
  Daypart = 'SIMPLIFI_DAYPART',
  Placement = 'SIMPLIFI_PLACEMENT',
  Deal = 'SIMPLIFI_DEAL',
  GeoFence = 'SIMPLIFI_GEO_FENCE',
  GeoFenceAttribution = 'SIMPLIFI_GEO_FENCE_ATTRIBUTION',
  Keyword = 'SIMPLIFI_KEYWORD',
}

export default SimplifiReportRequest;
